export default {
    de: {
        title: 'Aktuell können wir für Sie leider keine Angebote für eine Bau-/Immobilienfinanzierung erstellen.',
        description: 'Unser Partner kann für Sie nach passenden Angeboten suchen.',
        btnTitle: 'Bau-/Immobilienfinanzierung anfragen',
        btnSubtitle: 'kostenlos und unverbindlich',
    },
};
